import { useRef } from "react";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "app/redux-store-interactions";
import { useActiveCoachmark } from "contexts/coachmarks";
import { Picker, selectPicker } from "features/render";

import { Coachmark } from "./coachmark";

const PICKERS = [
    Picker.OutlineLaser,
    Picker.Coordinates,
    Picker.PointLine,
    Picker.Dimension,
    Picker.SectionPlane,
    Picker.Pins,
];

export function CoachmarkDisplay() {
    const { t } = useTranslation();

    const customCoachmark = useActiveCoachmark();

    const globalPicker = useAppSelector(selectPicker);
    const pickerRef = useRef(globalPicker);
    if (PICKERS.includes(globalPicker)) {
        pickerRef.current = globalPicker;
    }
    const picker = pickerRef.current;

    if (customCoachmark) {
        return (
            <Coachmark
                key={customCoachmark.id}
                label={customCoachmark.label}
                description={customCoachmark.tooltipMessage}
                buttonLabel={customCoachmark.buttonLabel}
                onButtonClick={customCoachmark.buttonOnClick}
                visible={true}
            />
        );
    }

    let label = "";
    let description = "";
    switch (picker) {
        case Picker.OutlineLaser:
            label = t("laser");
            description = t("laserHowTo");
            break;
        case Picker.Coordinates:
            label = t("coordinates");
            description = t("coordinatesHowTo");
            break;
        case Picker.PointLine:
            label = t("pointToPoint");
            description = t("pointToPointHowTo");
            break;
        case Picker.Dimension:
            label = t("dimension");
            description = t("dimensionHowTo");
            break;
        case Picker.Pins:
            label = t("pins");
            description = t("pinsHowTo");
            break;
        case Picker.SectionPlane:
            label = t("sectionPlane");
            description = t("sectionPlaneHowTo");
            break;
    }

    const visible = PICKERS.includes(globalPicker);

    return <Coachmark key={picker} label={label} description={description} visible={visible} />;
}
